import React from 'react';

import * as S from './InformationBlock.styles';
import { Button } from 'components/uikit/Button/Button';
import { useInformationPresenter } from './InformationBlock.presenter';
import { Avatar } from './Avatar';
import { Link } from 'components/uikit/Link/Link';

export const InformationBlock = ({ info, dataTest = '' }) => {
  const presenter = useInformationPresenter(info);
  return (
    <S.Card>
      <Avatar imgId={presenter.imgId} />
      <S.Main>
        <S.Title>{presenter.title}</S.Title>
        <S.Subtitle>{presenter.subtitle}</S.Subtitle>

        <S.InfoRow>
          <S.Label>Телефон</S.Label>
          <S.DataValue>
            <S.ClipboardCopyStyled value={presenter.phone} dataTest={`${dataTest}Phone-copy`}>
              {presenter.phone}
            </S.ClipboardCopyStyled>
          </S.DataValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.Label>Почта</S.Label>
          <S.DataValue>
            <Link href={`mailto:${presenter.email}`} size={'s'} theme={'3'}>
              {presenter.email}
            </Link>
            <S.ClipboardCopyStyled value={presenter.email} dataTest={`${dataTest}Email-copy`} />
          </S.DataValue>
        </S.InfoRow>
        {!!presenter.messengerButtons.length && (
          <S.ButtonRow>
            {presenter.messengerButtons.map((button) => (
              <Button
                key={button.label}
                onClick={() => window.open(button.url, '_blank', 'noopener,noreferrer')}
                theme="6"
                size="s"
                Icon={button.Icon}
                dataTest={button.dataTest}
              >
                {button.label}
              </Button>
            ))}
          </S.ButtonRow>
        )}
      </S.Main>
    </S.Card>
  );
};
